import {
  StatusEmissao,
  StatusEmissaoExibir,
} from "../../../../enums/StatusEmissaoEnum";
import { Container } from "./style";
interface Props {
  statusEmissao: StatusEmissao;
}

export function StatusEmissaoLicenciamento({ statusEmissao }: Props) {
  return (
    <Container statusEmissao={statusEmissao}>
      {StatusEmissaoExibir[statusEmissao]}
    </Container>
  );
}
